"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProgressBar_1 = require("./ProgressBar");
exports.default = ProgressBar_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ProgressBar/index.js
// module id = 1218
// module chunks = 8